<template>
  <div>
    <div
      :class="[
        'home-herder',
        { 'home-herder-scroll': scrollTop || screenWidth <= 1000 },
      ]"
    >
      <img
        class="logo"
        @click="goUrl('/')"
        v-if="!scrollTop && screenWidth > 1000"
        src="@/assets/image/common/logo-white.png"
      />
      <img
        class="logo"
        @click="goUrl('/')"
        v-else
        src="@/assets/image/common/logo-bule.png"
      />

      <div class="text-box">
        <div @click="goUrl('/home')" :class="[{ active: active === '/home' }]">
          {{ $t("home.homeHerder.title1") }}
          <span class="line" v-if="active === '/home'"></span>
        </div>
        <div @click="goUrl('/module/task')">
          {{ $t("home.homeHerder.title2") }}
          <span class="line" v-if="active === 'home1'"></span>
        </div>
        <div @click="goUrl('/module/exchange')">
          {{ $t("home.homeHerder.title3") }}
          <span class="line" v-if="active === 'home1'"></span>
        </div>
        <div @click="goUrl('/module/activity')">
          {{ $t("home.homeHerder.title4") }}
          <span class="line" v-if="active === 'home1'"></span>
        </div>
        <div @click="goUrl('/module/help')">
          {{ $t("home.homeHerder.title5") }}
          <span class="line" v-if="active === 'home1'"></span>
        </div>
        <div @click="goUrl('/commerce')">
          {{ $t("home.homeHerder.title6") }}
          <span class="line" v-if="active === '/commerce'"></span>
        </div>
        <div class="lang-box" @click="changeLang">
          <span>{{ $t("lang") }}</span>
        </div>
        <div class="btn">
          <span @click="goUrl('login')">{{
            $t("home.homeHerder.title7")
          }}</span>
          <span class="vertical"></span>
          <span @click="goUrl('register')">{{
            $t("home.homeHerder.title8")
          }}</span>
        </div>
      </div>

      <img
        class="storage"
        @click="show = !show"
        src="@/assets/image/common/storage.png"
      />
      <HerderList v-if="show" @close="show = false"></HerderList>
    </div>
  </div>
</template>
<script>
import HerderList from "@/components/Mobile/herderList2.vue";
export default {
  data() {
    return {
      scrollTop: 0,
      screenWidth: 0,
      active: "",
      show: false,
    };
  },
  components: { HerderList },
  methods: {
    //监听页面滚动
    scrollToTop() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log("333", this.scrollTop);
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      console.log("2222", this.screenWidth);
    },
    //改变语言
    changeLang() {
      if (this.$i18n.locale === "zn") {
        // 判断当前语言
        this.$i18n.locale = "en"; // 设置当前语言
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "zn";
        localStorage.setItem("lang", "zn");
      }
    },
    //跳转
    goUrl(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("scroll", this.scrollToTop);
    window.addEventListener("resize", this.handleResize);
    //赋值路由
    this.active = this.$route.path;
    this.scrollToTop();
  },
};
</script>
<style lang="scss" scoped>
.home-herder {
  width: 100%;
  height: 70px;
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 99;
  .logo {
    width: 145px;
    height: 50px;
    margin-left: 140px;
    cursor: pointer;
  }
  .text-box {
    display: flex;
    align-items: center;
    margin-left: 100px;
    color: #fff;

    div {
      margin-right: 60px;
      font-size: 16px;
      height: 70px;
      line-height: 70px;
      position: relative;
      cursor: pointer;
      flex-shrink: 0;
      .line {
        position: absolute;
        width: 16px;
        height: 2px;
        background-color: #fff;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .lang-box {
      display: flex;
      align-items: center;
      margin-right: 50px;
      cursor: pointer;
      .lang {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        font-size: 16px;
      }
    }
    .btn {
      margin-right: 0;
      line-height: 30px;
      padding: 0 12px;
      height: 30px;
      border-radius: 18px 18px 18px 18px;
      border: 1px solid #ffffff;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      .vertical {
        height: 16px;
        width: 1px;
        background-color: #fff;
        margin: 0 12px;
      }
    }
  }
  .storage {
    display: none;
    width: 36px;
    height: 36px;
    margin-right: 20px;
    cursor: pointer;
  }
}
.home-herder-scroll {
  background-color: #fff;
  box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.05);
  .active {
    color: #8948ff;
  }
  .text-box {
    color: #474f66;
    div {
      .line {
        background-color: #8948ff;
      }
    }
    .btn {
      border-color: #474f66;
      color: #474f66;
      .vertical {
        background-color: #474f66;
      }
    }
  }
}
</style>


<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1380px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 50px;
      div {
        margin-right: 50px;
      }
    }
  }
}

@media only screen and (max-width: 1140px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 40px;
      div {
        margin-right: 30px;
      }
    }
  }
}
@media only screen and (max-width: 1100px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 40px;
      div {
        margin-right: 30px;
      }
    }
  }
}
@media only screen and (max-width: 1000px) {
  .home-herder {
    display: flex;
    justify-content: space-between;
    .logo {
      margin-left: 20px;
    }
    .text-box {
      display: none;
    }
    .storage {
      display: block;
    }
  }
}
</style>